<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 tag">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="tag d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Almérő Lista</h5>
              </div>
              <div class="col-6 text-end">
                <material-button
                  class="float-right btn btm-sm"
                  @click="this.$router.push({ name: 'Add SubMeter' })"
                >
                  <i class="fas fa-tag me-2"></i>
                  Almérő Regisztráció
                </material-button>
              </div>
            </div>
          </div>

          <!-- Card body -->
          <div class="px-0 pb-0 card-body">
            
            <div class="table-responsive p-4">
            <!-- Table -->
            <DataTable id="dataTable" :data="data" :columns="columns" ref="table" class="table table-flush dataTable-table" width="100%">
              <template #action="props">
                <td
                    class = "dt-control"
                    :text="`Col 1: ${props.cellData}`"
                    @click="rowClick"
                ></td>
              </template>
            </DataTable>
          </div>
        
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import $ from "jquery";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import eventTable from "@/mixins/eventTable.js";
import store from "@/store";
import _ from "lodash";

DataTable.use(DataTablesCore);

import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import BasePagination from "@/components/BasePagination.vue";

var sortDirection = "created_at";

const getSubMetersList = _.debounce(async function (params) {
  await store.dispatch("meters/getSubMeters");
}, 300);

export default {
  name: "SubMetersList",
  components: {
    MaterialButton,
    MaterialInput,
    BasePagination,
    DataTable
  },
  mixins: [eventTable],
  setup() {
    const data = ref([]);
    const table = ref();
      const columns = [
          {
            //data: null,
            //className: 'dt-control',
            render: {
              //_: 'pod',
              display: '#action'
            },
            title: 'Action'
          },
          { title: 'POD' },
          { title: 'Gyári Szám' },
          { title: 'Beüzemelés Időpontja' },
          { title: '' },
        ];
        return {
            columns,
            data,
            table,
        }
  },
  data() {
    return {
      search: "",
      dataSubMeters: [],
      pagination: {},
      dataTable: null,
      keys: null,
    };
  },
  computed: {
    submetersList() {
      return this.$store.getters["submeters/getSubMetersData"];
    },
    metaPage() {
      return this.$store.getters["submeters/getSubMetersMeta"];
    },
  },
  watch: {
    submetersList: {
      handler: "reactiveTable",
      immediate: false,
      deep: true,
    },
  },
  async mounted() {
    await getSubMetersList({
        sort: sortDirection,
        query: "",
        //nr: getCurrentPage,
        //perpage: this.dataTable.options.perPage,
      });
  },
  beforeUnmount() {
    sortDirection = "created_at";
  },
  methods: {
    rowClick(event) {
        const table = $("#dataTable").DataTable();
        let tr = event.target.closest('tr');
        let row = table.row(tr);
    
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
        }
        else {
            // Open this row
            console.log(row.data());
            row.child(this.format(row.data())).show();
        }
    },
    format(d) {
      // `d` is the original data object for the row
      let areaHtml = "";
      areaHtml += '<table>'
      areaHtml += '<thead>'
      areaHtml += '<tr>'
      areaHtml += '<th>Szám</th>'
      areaHtml += '<th>Helyrajzi szám</th>'
      areaHtml += '<th>Bruttó méret</th>'
      areaHtml += '<th></th>'
      areaHtml += '<tr>'
      areaHtml += '</thead>'

      d[0].forEach(area => {
        areaHtml += '<tr>'
        areaHtml += `<td>${area.area_detail.area_nr}</td>`;
        areaHtml += `<td>${area.area_detail.lot_number}</td>`;
        areaHtml += `<td>${area.area_detail.gross_floor_space}</td>`;
        areaHtml += `<td>${this.actionDeleteButton(area.id, "Terület törlése")}</td>`;
        areaHtml += '<tr>'
      });

      areaHtml += '</table>'

      return (
          `<dl>
          <dt>Szolgáltató információ:</dt>
          <dl>
          <table>
            <tr>
              <td>${d[1]}</td>
            </tr>
          </table>
          </dd>
          <dt>Helységek:</dt>
          <dd>${areaHtml}</dd>
          </dl>`
      );
    },

    async getDataFromPage(page) {
      await getSubMetersList({
        sort: sortDirection,
        query: this.search,
        nr: page,
        perpage: this.dataTable.options.perPage,
      });
    },

    async reactiveTable() {
      this.dataSubMeters = [];
      if (this.submetersList.length > 0) {
        this.submetersList.forEach((submeter) => {
          this.dataSubMeters.push([
          submeter.realestate_id,
          submeter.area_id,
          submeter.meter_pod,
          submeter.name,
          
            `<div class="text-end">${
              this.actionEditButton(submeter.id, "Almérő módosítása") +
              this.actionDeleteButton(submeter.id, "Almérő törlése")
            }</div>`,
          ]);
        });
        this.dataTable.data = [];
        this.dataTable.refresh();
        this.dataTable.insert({ data: this.dataSubMeters });
        this.removeEvent();
        this.eventToCall({
          table: this.dataTable,
          myUserId: null,
          redirectPath: "Edit SubMeter",
          deletePath: "submeters/deleteSubMeter",
          getPath: "submeters/getSubMeters",
          textDelete: "Almérő sikeresen törölve!",
          textDefaultData: "submeters",
        });
      } else {
        this.dataTable.setMessage("Nincs a keresési feltételnek megfelelő találat.");
      }
    },
  },
};
</script>
